import '@babel/polyfill'
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './lib/vue-globals'
import vuetify from './plugins/vuetify'
import './plugins/vue-wysiwyg'
import 'vue-wysiwyg/dist/vueWysiwyg.css'

import 'viewerjs/dist/viewer.css'
import Viewer from 'v-viewer'
import VueSilentbox from 'vue-silentbox'

Vue.config.productionTip = false

//Vue.use(MultiFiltersPlugin) // <-- THIS
Vue.use(Viewer)
Vue.use(VueSilentbox)

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
